import { Platform, NativeModules } from 'react-native';
import { Device, getDeviceAspectRatio } from 'DeviceUtils';
import { MCORE_SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './options';

let defaultLang = String(DEFAULT_LANGUAGE);
// Compatibility fallback
const getIosDefaultLang = () =>
    NativeModules.SettingsManager.settings.AppleLocale ||
    NativeModules.SettingsManager.settings.AppleLanguages[0];
try {
    const getPhoneLocale = () =>
        Platform.OS === 'ios' ? getIosDefaultLang() : NativeModules.I18nManager.localeIdentifier;
    const deviceLocale = Device.isWeb ? navigator.languages[0] : getPhoneLocale();
    defaultLang = deviceLocale.slice(0, 2);
    // If system language is not supported, fall back to default lang
    if (!MCORE_SUPPORTED_LANGUAGES.includes(defaultLang)) {
        defaultLang = String(DEFAULT_LANGUAGE);
    }
} catch (err) {
    console.log('Failed to get system language', err);
}

export default {
    language: defaultLang,
    aspectRatio: getDeviceAspectRatio(),
    videoQualityProfile: 'p0',
    downloadProfile: 'p0',
    autoPlayNextItem: true,
    rememberPassword: true,
    onboardingCompleted: false,
    enforceChangePasswordShow: true,
    cookieConsentGiven: false,
    // Network settings
    showMobileNetworkWarning: true,
    videoStreamingOverCellular: false,
    downloadsOverCellular: false,
    // Parental settings
    autoParentalLockInterval: 30,
    playerVolume: 1,
    epgSelectedListMode: '',
    isNewFeaturesChecked: false
};
